import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-black pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-20 gap-16">
          <div className="max-w-md">
            <div className="mb-8">
              <span className="logo-font font-black text-3xl tracking-tighter text-white flex items-center">
                FENGSHUI<span className="text-brand-red text-4xl font-black">X</span>
              </span>
            </div>
            <h3 className="text-zinc-200 font-black text-xl mb-6 uppercase tracking-widest leading-snug">
              BAZI FINANCIAL & <br /> INVESTMENT
            </h3>
            <p className="text-zinc-500 leading-relaxed font-medium">
              หลักสูตรเจาะลึกปาจื้อสายการเงินและการลงทุน <br />
              โดย อ.รวิ อัญญากาญจน์ — Bazi.Fengshuix.com
            </p>
          </div>

          <div className="w-full lg:w-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-zinc-900/50 border border-zinc-800 p-8 hover:border-brand-red transition-all group">
                <p className="text-zinc-500 font-black uppercase tracking-widest text-[10px] mb-4">Official Line</p>
                <a href="https://line.me/ti/p/@fengshuix" target="_blank" rel="noreferrer" className="text-white font-black text-xl hover:text-brand-red transition-colors">
                  @fengshuix
                </a>
              </div>
              <div className="bg-brand-red p-8 hover:bg-white group transition-all duration-500">
                <p className="text-white/70 group-hover:text-zinc-500 font-black uppercase tracking-widest text-[10px] mb-4">Call Support</p>
                <a href="tel:0988505900" className="text-white group-hover:text-zinc-900 font-black text-xl transition-colors">
                  098-850-5900
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-8">
          <p className="text-zinc-700 text-[10px] font-black uppercase tracking-[0.3em]">
            © {new Date().getFullYear()} FENGSHUIX · ALL RIGHTS RESERVED
          </p>
          <div className="flex gap-8">
             <span className="text-brand-red text-[10px] font-black uppercase tracking-[0.3em]">MULTIPLY YOUR VALUE</span>
          </div>
        </div>
      </div>
    </footer>
  );
}